var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_c('form', {
    attrs: {
      "data-testid": "visit-voucher-form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveVoucher($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicalDevice"
    }
  }, [_vm._v("Zdravotnický prostředek")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicalDevice",
      "label": "label",
      "track-by": "code",
      "open-direction": "bottom",
      "placeholder": "vyhledat zdravotnický prostředek",
      "data-testid": "visit-voucher-device-search",
      "options": _vm.medicalDevices,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 400,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat"
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.selectMedicalDevice
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [(props.option.has_actual_insruance_cover === true) ? _c('i', {
          staticClass: "fas fa-coins",
          staticStyle: {
            "color": "goldenrod"
          }
        }) : _vm._e(), _vm._v("\n                                  " + _vm._s(props.option.label) + "\n                                ")])]), _vm._v(" "), _c('div', {
          staticClass: "row m-0 font-xs font-weight-normal"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_c('span', [_vm._v("\n                                     " + _vm._s(props.option.description) + "\n                                  ")])])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.voucherError.medicalDevice) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicalDeviceError"
    }
  }, [_vm._v(_vm._s(_vm.voucherError.medicalDevice.message))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 mb-2"
  }, [(_vm.clientMedicalDeviceInfoPending === true) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x fa-fw"
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDiagnosis"
    }
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchDiagnosis",
      "label": "label",
      "track-by": "code",
      "data-testid": "visit-voucher-disease-search",
      "placeholder": "vyhledat diagnózu",
      "options": _vm.diseases,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getDiseases,
      "select": _vm.selectDisease
    },
    model: {
      value: (_vm.selectedDisease),
      callback: function($$v) {
        _vm.selectedDisease = $$v
      },
      expression: "selectedDisease"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "paidBySick"
    }
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.paid_by_sick),
      expression: "voucher.paid_by_sick"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "paidBySick",
      "checked": "",
      "data-testid": "visit-voucher-paid-by-client"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.paid_by_sick) ? _vm._i(_vm.voucher.paid_by_sick, null) > -1 : (_vm.voucher.paid_by_sick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.paid_by_sick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.paid_by_sick = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.paid_by_sick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.paid_by_sick = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-begin"
  }, [_c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Počet balení")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.amount),
      expression: "voucher.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "min": "1",
      "data-testid": "visit-voucher-quantity"
    },
    domProps: {
      "value": (_vm.voucher.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "temporary"
    }
  }, [_vm._v("Dočasná")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.temporary),
      expression: "voucher.temporary"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "temporary",
      "checked": "",
      "data-testid": "visit-voucher-temporary"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.temporary) ? _vm._i(_vm.voucher.temporary, null) > -1 : (_vm.voucher.temporary)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.temporary,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.temporary = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.temporary = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.temporary = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "temporary_duration_months"
    }
  }, [_vm._v("na počet měsíců")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.temporary_duration_months),
      expression: "voucher.temporary_duration_months"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "temporary_duration_months",
      "min": "1",
      "max": "365",
      "data-testid": "visit-voucher-temporary-months"
    },
    domProps: {
      "value": (_vm.voucher.temporary_duration_months)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.temporary_duration_months = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "family"
    }
  }, [_vm._v("Rodina")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.family),
      expression: "voucher.family"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "family",
      "checked": "",
      "data-testid": "visit-voucher-family"
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.family) ? _vm._i(_vm.voucher.family, null) > -1 : (_vm.voucher.family)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.family,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.family = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.family = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.family = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "validityInDays"
    }
  }, [_vm._v("Platnost (dní)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.validity_in_days),
      expression: "voucher.validity_in_days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "validityInDays",
      "min": "1",
      "max": "365",
      "data-testid": "visit-voucher-validity"
    },
    domProps: {
      "value": (_vm.voucher.validity_in_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.voucher.validity_in_days = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text font-weight-bold"
  }, [_vm._v("do " + _vm._s(_vm.validToDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "incontinence_grade"
    }
  }, [_vm._v("Stupeň inkontinence")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === null
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-none"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.voucher.incontinence_grade, null)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = null
      }
    }
  }), _vm._v(" ne\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 1)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 1
      }
    }
  }), _vm._v(" 1\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 2)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 2
      }
    }
  }), _vm._v(" 2\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.incontinence_grade === 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.incontinence_grade),
      expression: "voucher.incontinence_grade"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "data-testid": "visit-voucher-incontinence-3"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.voucher.incontinence_grade, 3)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.incontinence_grade = 3
      }
    }
  }), _vm._v(" 3\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("E-Poukaz")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.electronic_prescription),
      expression: "voucher.electronic_prescription"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "type",
      "data-testid": "visit-voucher-electronic",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.voucher.electronic_prescription) ? _vm._i(_vm.voucher.electronic_prescription, null) > -1 : (_vm.voucher.electronic_prescription)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.voucher.electronic_prescription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.voucher.electronic_prescription = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.voucher.electronic_prescription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.voucher.electronic_prescription = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "notification"
    }
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.patient_notification_type),
      expression: "voucher.patient_notification_type"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "notification",
      "id": "notification",
      "disabled": _vm.voucher.electronic_prescription !== true,
      "data-testid": "visit-voucher-notification"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.voucher.patient_notification_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clientMedicalDeviceInfo.possible_notifications), function(pn, index) {
    return _c('option', {
      domProps: {
        "value": pn.key
      }
    }, [_vm._v(_vm._s(pn.label) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "payment"
    }
  }, [_vm._v("Úhrada (UHR)")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === null
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-none"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.voucher.payment, null)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = null
      }
    }
  }), _vm._v(" ne\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 1
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-1"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.voucher.payment, 1)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 1
      }
    }
  }), _vm._v(" 1\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 2
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-2"
    },
    domProps: {
      "value": 2,
      "checked": _vm._q(_vm.voucher.payment, 2)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 2
      }
    }
  }), _vm._v(" 2\n              ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.voucher.payment === 3
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.voucher.payment),
      expression: "voucher.payment"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option4",
      "autocomplete": "off",
      "data-testid": "visit-voucher-payment-3"
    },
    domProps: {
      "value": 3,
      "checked": _vm._q(_vm.voucher.payment, 3)
    },
    on: {
      "__c": function($event) {
        _vm.voucher.payment = 3
      }
    }
  }), _vm._v(" 3\n              ")])])])]), _vm._v(" "), _vm._m(0)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "data-testid": "visit-voucher-submit"
    }
  }, [_vm._v("Vystavit poukaz")])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6644368b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Voucher/AddVoucher.vue
// module id = 591
// module chunks = 0